import React, { useContext, useEffect } from "react";
import { AppContext } from "../../../util/context";
import AnswerInput from "../InputFields/AnswerInput";
import { QuestionStep } from "./StepQuestion.types";
import { medicalSurveyCalculatedResult } from "../../../util/functions";
import { AnswerData, Answer } from "../InputFields/InputFields.types";
import styles from "./StepQuestion.module.scss";
import block from 'bem-css-modules';
import Loader from "../../Loader";

const StepQuestion = (props: { stepData: QuestionStep, activeStepIndex: number, stepIndex: number }) => {
  const context = useContext(AppContext);
  const { handleStepSubmit, disableButton, settings: { crm } } = context;
  const { product } = crm[0];
  const {
    activeStepIndex,
    stepIndex,
    stepData: {
      medicalSurveyResult,
      stepSettings: [{
        uuid,
        label,
        customNextButton,
        classes,
        nextStep,
        lastStep,
      }],
      question,
      answers,
      crmProperty,
    },
  } = props;

  const b = block(styles);

  const onCLick = (data: Answer) => {

    const stepData = {
      answer: data,
      label: label,
      uuid: uuid,
      settings: {
        tracking: {
          gtmEvent: `formClient.step.${label}`
        },
        classes,
        custom_next_button: customNextButton,
        next_step: nextStep,
        last_step: lastStep,
        crm_field: crmProperty
      },
    }

    handleStepSubmit(context, stepData)

    if (!medicalSurveyResult) return;
    if (stepIndex === activeStepIndex) {
      const msResult = medicalSurveyCalculatedResult(product);
      if(!msResult) return;
      window.sessionLayer.pushToSession("calculated_ms_value", msResult.resultValue);
      window.sessionLayer.pushToSession("calculated_ms_description", msResult.resultDescription);
    }
  }

  return (
    <div className={b()} >
      {question && <h4 className={`fc-question ${b("question")}`} dangerouslySetInnerHTML={{ __html: question }} />}
      {disableButton && (
        <div className={b("disable-button")}>
          <Loader />
        </div>
      )}
      {answers?.map((button: AnswerData, i: number) => {
        return <AnswerInput key={i} stepLabel={label} buttonData={button} onAnswerCLick={onCLick} />;
      })}
    </div>
  )
}

export default StepQuestion;